<template>
    <ModalBase :with-content="true" @close="close">
        <h1>{{ $t("plano.editor.header.file.renamePlanogram.labelRenamePlano") }} :</h1>
        <p><input type="text" v-model="newName" :class="{ empty: !hasName }" /></p>
        <footer>
            <ClientColorButton :disabled="!hasName" @click="renamePlano">
                {{ $t("plano.editor.header.file.renamePlanogram.valider") }}
            </ClientColorButton>
            <ClientColorButton @click="$emit('close');"> {{ $t("plano.editor.header.file.renamePlanogram.close") }} </ClientColorButton>
        </footer>
    </ModalBase>
</template>

<script>
import ModalBase from "@/components/modal/ModalBase";
import ClientColorButton from "@/components/ui/ClientColorButton";
import { isValidNameLength } from "@/utils/string";

export default {
    props: { plano: Object },
    components: { ModalBase, ClientColorButton },
    data: () => ({
        newName: undefined
    }),
    created() {
        this.newName = this.plano.name;
    },
    methods: {
        close() {
            this.$emit("close");
        },
        async renamePlano() {
            if (this.hasName) {
                this.$emit("nameChanged", this.newName.trim());
                this.close();
            }
        }
    },
    computed: {
        hasName() {
            return isValidNameLength(this.newName);
        }
    }
};
</script>

<style scoped lang="scss">
input {
    padding: 5px;
    font-size: 12px;
    font-family: Roboto, Sans-Serif;
    &.empty {
        border: 1px solid red;
    }
}
</style>



// WEBPACK FOOTER //
// modalEditPlanoName.vue?78e2a6df